import User from './User';
import FHEProduct from './FHEProduct';

export default socketMiddleware => {
    return Object.assign({}, User(socketMiddleware), FHEProduct(socketMiddleware));
};



// WEBPACK FOOTER //
// ./environments/myfhe/eventsSocket/index.js